<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Historial de caja chica</h2>
    <MainPettyCashHistory />
  </div>
</template>

<script>
import MainPettyCashHistory from "@/components/PettyCash/MainPettyCashHistory.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";

export default {
  name: "PettyCashHistoryView",
  components: {
    MainPettyCashHistory,
  },
  setup() {
    const route = useRoute();

    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>